import  React, { useCallback } from 'react';
import { CoverDataItem } from '../../../../utils/models';
import { getAnomalyId } from '../../../../utils/utilities';

interface AnomalyRemarksProps {
    anomaly: { id: number; recommendation: CoverDataItem[] };
    lineNumberID?: number;
    anomalyIndex?: number;
}

const AnomalyRemarks: React.FC<AnomalyRemarksProps> = ({ anomaly, anomalyIndex, lineNumberID }): any => {
    const replaceTypoInRemark = useCallback((recommendation: string) => {
        return recommendation.replace('Repair Replacement Required', 'Repair or Replacement Required').replace(/\s+/g, ' ');
    }, []);

    const renderID = useCallback((descriptionIndex: number) => {
        if (lineNumberID && anomalyIndex) {
            return `${getAnomalyId(lineNumberID, anomalyIndex)}.${descriptionIndex + 1}`
        }

        return `${getAnomalyId(anomaly.id, descriptionIndex + 1)}`;
    }, [lineNumberID, anomalyIndex, anomaly.id]);

    return anomaly.recommendation.map((recommendation, index) => (
        <div key={recommendation.value} className="mt-2 d-flex justify-content-start align-items-start">
            <div className="text-start fw-bold me-1">{renderID(index)}</div>
            <div className="flex-fill text-start text-break">
                {replaceTypoInRemark(recommendation.value)}
            </div>
        </div>
    ));
}
 
export default AnomalyRemarks;